import { IGetPatrimonioChecklistInfoUseCase } from "../../../presentation/useCases/read/get_patrimonio_checklist_info_use_case";
import { PatrimonioChecklistInfo } from "../../models/patrimonio_checklist_info";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * GetPatrimonioChecklistInfoUseCase
 */

export class GetPatrimonioChecklistInfoUseCase implements IGetPatrimonioChecklistInfoUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async getPatrimonioChecklistInfo(
    idPatrimonioCentroCusto: number,
    idPatrimonioMaquinaEquip?: number,
    idInspecaoPatrimonio?: number,
  ): Promise<PatrimonioChecklistInfo> {
    return this.repository.getPatrimonioChecklistInfo(
      idPatrimonioCentroCusto,
      idPatrimonioMaquinaEquip,
      idInspecaoPatrimonio,
    );
  }
}
